// Node modules
import { nanoid } from 'nanoid';

// Components
import Item from './Item';

// Themes
import theme from '@/themes/index';

const Keys = ({
  content, 
}) => (
  <>
    <div className='container'>
      <div className='items-container'>
        {content.map(item => (
          <Item key={nanoid()} content={item.key} />
        ))}
      </div>
    </div>
    <style jsx>{`
      .container {
        height: auto;
        display: flex;
        flex-direction: column;
      }
      .container .items-container {
        flex-direction: row;
        justify-content: center;
        height: 100%;
        display: flex;
        flex-direction: column-reverse;
        gap: 1rem;
        padding: 0 2rem;
      }
      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        .container .items-container {
          align-items: center;
        }
      }
      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        .container {
          height: 19.125rem;
        }
        .container .items-container {
          display: flex;
          width: 100%;
          gap: 4rem;
          flex-direction: row;
          padding: 0;
          align-items: center;
        }
      }
    `}</style>
  </>
);

export default Keys;
